import { render, staticRenderFns } from "./ConfirmReceipt.vue?vue&type=template&id=5369f64c&"
import script from "./ConfirmReceipt.vue?vue&type=script&lang=js&"
export * from "./ConfirmReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports